import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { smoothScrollToTop } from '../../utils/scrolling';
const ReactRouterSmoothScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useLayoutEffect(() => {
    smoothScrollToTop();
  }, [pathname]);
  return null;
};
export default ReactRouterSmoothScrollToTop;